import { render, staticRenderFns } from "./HistoryItem.vue?vue&type=template&id=03088965&scoped=true&"
import script from "./HistoryItem.vue?vue&type=script&lang=js&"
export * from "./HistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./HistoryItem.vue?vue&type=style&index=0&id=03088965&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03088965",
  null
  
)

export default component.exports